import { renderRichText, storyblokEditable } from "@storyblok/react";
import { ExternalFormsModel } from "./ExternalFormsModel";
import { useEffect, useRef } from "react";
import Utils from "../../core/Utils/Utils";

import "./ExternalForms.css";
import ExternalFormsUtils from "./ExternalFormsUtils";

const ExternalForms: React.FC<{ blok: ExternalFormsModel }> = ({ blok }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const bodyHTML = renderRichText(blok.body) || "";

  useEffect(() => {
    if (!blok || !containerRef.current) return;

    const container = containerRef.current as HTMLDivElement;
    const scripts = Utils.getScripts(container, blok.script);
    Utils.loadScripts(scripts, containerRef);

    ExternalFormsUtils.waitForIframeAndApplyStyles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      {...storyblokEditable(blok)}
      className={`external-forms ${blok.display}`}
      style={{ backgroundColor: blok.backgroundColor }}
    >
      <div className="mobile-title">
        <span>{blok.title}</span>
      </div>
      <div className="container" style={{ color: blok.textColor }}>
        <div className="first-block">
          <div className="title" style={{ color: blok.textColor }}>
            {blok.title}
          </div>
          <div
            className="body"
            style={{ color: blok.textColor }}
            dangerouslySetInnerHTML={{ __html: bodyHTML }}
          ></div>
        </div>
        <div className="second-block" ref={containerRef}></div>
      </div>
    </div>
  );
};

export default ExternalForms;
